$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function () {


  $(document).on('click','.js-sub-main-purchase',function(e){
    e.preventDefault();
    var sub_main_qty = $(".main_sub_qty").val();
    var items = Array();
    var item = {};
    item.id = window.brushboxv3.sub_product.variant_id;
    item.quantity = sub_main_qty;
    item.properties = {};
    item.properties.subscription_id = window.brushboxv3.sub_product.subscription_id;
    item.properties.shipping_interval_frequency = window.brushboxv3.sub_product.interval_unit_type;
    item.properties.shipping_interval_unit_type = window.brushboxv3.sub_product.interval_unit;
    items.push(item);

    if( $("#box2:checked").length > 0 ) {
      if($(".sub_main_addon_adult_qty").val() > 0) {
        item = {};
        item.id = window.brushboxv3.sub_product_adult_addon.variant_id;
        item.quantity = $(".sub_main_addon_adult_qty").val();
        item.properties = {};
        item.properties.subscription_id = window.brushboxv3.sub_product_adult_addon.subscription_id;
        item.properties.shipping_interval_frequency = window.brushboxv3.sub_product_adult_addon.interval_unit_type;
        item.properties.shipping_interval_unit_type = window.brushboxv3.sub_product_adult_addon.interval_unit;
        items.push(item);

      }

      if($(".sub_main_addon_kids_qty").val() > 0) {
        item = {};
        item.id = window.brushboxv3.sub_product_kids_addon.variant_id;
        item.quantity = $(".sub_main_addon_kids_qty").val();
        item.properties = {};
        item.properties.subscription_id = window.brushboxv3.sub_product_kids_addon.subscription_id;
        item.properties.shipping_interval_frequency = window.brushboxv3.sub_product_kids_addon.interval_unit_type;
        item.properties.shipping_interval_unit_type = window.brushboxv3.sub_product_kids_addon.interval_unit;
        items.push(item);
      }
    }

    $.ajax({
      url : "/cart/add.js",
      data : { items : items},
      method : "POST",
      dataType : "JSON",
      success : function(data) {
        window.location = window.brushboxv3.rc_url();
      },
      error : function(error){

      }
    });
  });

  $(document).on('click','.js-otp-main-purchase',function(e){
    e.preventDefault();
    var items = Array();
    var item = {};
    item.id = window.brushboxv3.otp_product;
    item.quantity = $(".otp_main_qty").val();
    items.push(item);

    if( $("#box3:checked").length > 0 ) {
      if($(".otp_main_addon_adults_qty").val() > 0) {
        item = {};
        item.id = window.brushboxv3.otp_product_adults;
        item.quantity = $(".otp_main_addon_adults_qty").val();
        items.push(item);

      }

      if($(".otp_main_addon_kids_qty").val() > 0) {
        item = {};
        item.id = window.brushboxv3.otp_product_kids;
        item.quantity = $(".otp_main_addon_kids_qty").val();
        items.push(item);
      }
    }

    $.ajax({
      url : "/cart/add.js",
      data : { items : items},
      method : "POST",
      dataType : "JSON",
      success : function(data) {
        window.location = "/checkout/"
      },
      error : function(error){

      }
    });
  });



  $(document).on('click','.js-sub-optional-purchase',function(e){
    e.preventDefault();
    var sub_main_qty = $(".optional_sub_qty").val();
    var items = Array();
    var item = {};    
    if( $("#box4:checked").length > 0 ) {      
        item = {};
        item.id = window.brushboxv3.sub_product_adult_addon_1.variant_id;
        item.quantity = sub_main_qty;
        item.properties = {};
        item.properties.subscription_id = window.brushboxv3.sub_product_adult_addon_1.subscription_id;
        item.properties.shipping_interval_frequency = window.brushboxv3.sub_product_adult_addon_1.interval_unit_type;
        item.properties.shipping_interval_unit_type = window.brushboxv3.sub_product_adult_addon_1.interval_unit;
        items.push(item);
    } else {
      item.id = window.brushboxv3.sub_product_1.variant_id;
      item.quantity = sub_main_qty;
      item.properties = {};
      item.properties.subscription_id = window.brushboxv3.sub_product_1.subscription_id;
      item.properties.shipping_interval_frequency = window.brushboxv3.sub_product_1.interval_unit_type;
      item.properties.shipping_interval_unit_type = window.brushboxv3.sub_product_1.interval_unit;
      items.push(item);
    }

    $.ajax({
      url : "/cart/add.js",
      data : { items : items},
      method : "POST",
      dataType : "JSON",
      success : function(data) {
        window.location = window.brushboxv3.rc_url();
      },
      error : function(error){

      }
    });
  });


  $(document).on('click','.js-otp-optional-purchase',function(e){
    e.preventDefault();
    var items = Array();
    var item = {};
    item.id = window.brushboxv3.otp_product_1;
    item.quantity = $(".otp_optional_qty").val();
    items.push(item);

    if( $("#box5:checked").length > 0 ) {      
        item = {};
        item.id = window.brushboxv3.otp_product_1_adults;
        item.quantity = $(".otp_optional_qty").val();
        items.push(item);
    }

    $.ajax({
      url : "/cart/add.js",
      data : { items : items},
      method : "POST",
      dataType : "JSON",
      success : function(data) {
        window.location = "/checkout/";
      },
      error : function(error){

      }
    });
  });

  $.get("/cart/clear",function(){console.log("Cleared")});

  $(".agewise").fadeOut(50);
  $(".money").each(function(ix,em){
    var html = $(em).html().trim();
    $(em).html(html);
  });


  $(document).on('change','#box2,#box3',function(e){
    var target = e.target;
    if ($(target).prop('checked') == true) {
      $(target).parents(".procards").eq(0).find('.agewise').fadeIn(100);
    } else {
      $(target).parents(".procards").eq(0).find('.agewise').fadeOut(100);
    }
  });

  $(window).on('scroll', function () {
    if ($('.custom-btn').eq(0).isInViewport() ||
      $('.custom-btn').eq(1).isInViewport() ||
      $('.custom-btn').eq(2).isInViewport() ||
      $('.custom-btn').eq(3).isInViewport() ||
      $('.custom-btn').eq(4).isInViewport() ||
      $('.custom-btn').eq(5).isInViewport() ||
      $('.custom-btn').eq(6).isInViewport() ||
      $('.custom-btn').eq(7).isInViewport() ||
      $('.custom-btn').eq(8).isInViewport() ||
      $('#checkout').isInViewport()) {
      $('.stickybtn').addClass('hidebtn');
    }
    else {
      $('.stickybtn').removeClass('hidebtn');;
    }
  });


  /* scroll to target */
  jQuery('.scrollTo').click(function (e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 800);
    e.preventDefault();
  });

  /* initialize fancybox */
  $(".fancybox").fancybox();


  /*faq*/
  $(".accord-title").click(function () {
    $(this).toggleClass("close-slide");
    $(this).next(".accord-body").slideToggle();
    $(".accord-body").not($(this).next(".accord-body")).slideUp();
    $(".accord-title").not($(this)).removeClass("close-slide");
    $(this).parent().toggleClass('openaccord');
    $(this).parent().siblings().removeClass('openaccord');
  });

  document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  $('.gocheck').on('click', function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top
    }, 900, 'swing', function () {
      // window.location.hash = target;
    });
  });

  $('.reviewsllides').slick({
    adaptiveHeight: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: 'ondemand',
    prevArrow: "<i class='fas fa-chevron-left left slick-arrow'></i>",
    nextArrow: "<i class='fas fa-chevron-right right slick-arrow'></i>",
  });

  $('.ingredientsslide').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: 'ondemand',
    prevArrow: "<i class='fas fa-chevron-left left slick-arrow'></i>",
    nextArrow: "<i class='fas fa-chevron-right right slick-arrow'></i>",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });

  String.prototype.getDecimals || (String.prototype.getDecimals = function () {
    var a = this,
      b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
  });
  jQuery(document).on("click", ".plus, .minus", function () {
    var a = jQuery(this).closest(".quantity").find(".qty"),
      b = parseFloat(a.val()),
      c = parseFloat(a.attr("max")),
      d = parseFloat(a.attr("min")),
      e = a.attr("step");
    b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
    a.attr('value', a.val());
  });


  $('.ingrideintimg').matchHeight({ byRow: true });

  $('.ttlingrdent').matchHeight({ byRow: true });


  $('.yearsupply .procards .optionocoose').matchHeight({ byRow: false });

  $('.optionocoose .form-group').matchHeight({ byRow: true });

  $('.leaving h5').matchHeight({ byRow: true });


  $('.expand-btn').click(function(){
    //$('.leavwrap .expand-btn').show();
    //$(this).siblings('.expand-btn').removeClass('.opened');
    //$('.content-leave-text').siblings('.content-leave-text').slideUp();
    //$(this).toggleClass('opened');
    //$(this).next('.leavwrap .content-leave-text').slideToggle();
    

    if ($(this).hasClass("opened")) {
      $(this).removeClass("opened");
      $(this).siblings(".leavwrap .content-leave-text").slideUp();
    }
    else {
      $(".expand-btn").removeClass("opened");
      $(this).addClass("opened");
      $(".leavwrap .content-leave-text").slideUp();
      $(this).siblings(".leavwrap .content-leave-text").slideDown();
    }
  });

});